<template>
      <embed style="position: absolute;top: 0px;left: 0px;width: 100%;height: 100%" src="/static/afterservice.pdf" />
</template>

<script>
export default {
  name: "aftersaleServicePdf"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AftersaleServicePdf.vue